<section class="mt-2" *ngIf="(showExportButtons || showFilters) && !hideSummary">
  <ngx-button-eksport-xls *ngIf="showExportButtons" class="mr-2" [dane]="dane" [kolumny]="eksportKolumny"
    nazwa="platnosci"></ngx-button-eksport-xls>
  <ngx-button-eksport-pdf *ngIf="showExportButtons" class="mr-2" [dane]="dane" [kolumny]="eksportKolumny"
    [kolumnyStyle]="eksportPdfKolumnyStyle" nazwa="platnosci" nazwaRaportu="{{ 'tytul.platnosci' | translate }}"
    [zakresDat]="zakresDat"></ngx-button-eksport-pdf>
  <button *ngIf="showFilters" nbButton size="small" (click)="wyswietlanieFiltrow = !wyswietlanieFiltrow">{{
    wyswietlanieFiltrow == true ? ('akcja.ukryj-filtry' | translate) : ('akcja.pokaz-filtry' | translate) }}</button>
</section>

<!-- Widok desktopowy - tabela -->
<div class="desktop-view">
  <ngx-datatable class="bootstrap" [rows]="dane" [summaryRow]="true" [summaryPosition]="'bottom'" [headerHeight]="45"
    [rowHeight]="45" [footerHeight]="50" [columnMode]="'flex'" [messages]="komunikatyTabeli" [limit]="15">
    <ngx-datatable-column headerClass="font-weight-bold" prop="liczbaPorzadkowa" name="{{ 'etykieta.lp' | translate }}"
      cellClass="text-right" [flexGrow]="1" [summaryFunc]=null>
    </ngx-datatable-column>

    <ngx-datatable-column prop="faktura" name="{{ 'etykieta.faktura' | translate }}" cellClass="text-center"
      [flexGrow]="2" [headerTemplate]="hdrTpl">
    </ngx-datatable-column>

    <ngx-datatable-column prop="dataWystawienia" name="{{ 'etykieta.data-wystawienia' | translate }}"
      cellClass="text-center" [flexGrow]="2" [headerTemplate]="hdrTpl">
    </ngx-datatable-column>

    <ngx-datatable-column prop="terminPlatnosci" name="{{ 'etykieta.termin-platnosci' | translate }}"
      cellClass="text-center" [flexGrow]="2" [headerTemplate]="hdrTpl">
    </ngx-datatable-column>

    <ngx-datatable-column prop="kwota" name="{{ 'etykieta.kwota' | translate }}" cellClass="text-right" [flexGrow]="2"
      [headerTemplate]="hdrTpl" [summaryFunc]="sumaKwota">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="kwotaZaplacona" name="{{ 'etykieta.kwota-zaplacona' | translate }}"
      cellClass="text-right" [flexGrow]="2" [headerTemplate]="hdrTpl" [summaryFunc]="sumaKwota">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="kwotaPozostala" name="{{ 'etykieta.kwota-pozostala' | translate }}"
      cellClass="text-right" [flexGrow]="2" [headerTemplate]="hdrTpl" [summaryFunc]="sumaKwota">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column headerClass="font-weight-bold text-wrap" prop="url"
      name="{{ 'etykieta.pobierz-fakture' | translate }}" cellClass="text-center" [flexGrow]="1">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <a *ngIf="value" target="_blank" [href]="value">{{ 'akcja.pobierz' | translate }}</a>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>

<!-- Widok mobilny - kafelki -->
<div class="mobile-view">
  <!-- Filtr dla widoku mobilnego -->
  <div class="mobile-filter mb-3" *ngIf="wyswietlanieFiltrow && showFilters">
    <input nbInput fullWidth type="search" placeholder="{{ 'etykieta.szukaj' | translate }}"
      (input)="updateFilterMobile($event)" />
  </div>

  <!-- Podsumowanie dla widoku mobilnego -->
  <nb-card accent="info" *ngIf="dane && dane.length > 0 && !hideSummary">
    <nb-card-header>
      <span class="font-weight-bold">{{ 'etykieta.podsumowanie' | translate }}</span>
    </nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="col-4">
          <div class="stat-label">{{ 'etykieta.suma-kwot' | translate }}</div>
          <div class="stat-value text-primary">{{ sumaKwot() | kwota }}</div>
        </div>
        <div class="col-4">
          <div class="stat-label">{{ 'etykieta.suma-zaplaconych' | translate }}</div>
          <div class="stat-value text-success">{{ sumaKwotZaplaconych() | kwota }}</div>
        </div>
        <div class="col-4">
          <div class="stat-label">{{ 'etykieta.suma-pozostalych' | translate }}</div>
          <div class="stat-value text-danger">{{ sumaKwotPozostalych() | kwota }}</div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Kafelki z danymi -->
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let item of dane; let i = index">
      <nb-card>
        <nb-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">{{ item.faktura }}</span>
            <span class="text-muted">#{{ item.liczbaPorzadkowa }}</span>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="row mb-2">
            <div class="col-6">
              <div class="stat-label">{{ 'etykieta.data-wystawienia' | translate }}</div>
              <div class="stat-value">{{ item.dataWystawienia }}</div>
            </div>
            <div class="col-6">
              <div class="stat-label">{{ 'etykieta.termin-platnosci' | translate }}</div>
              <div class="stat-value">{{ item.terminPlatnosci }}</div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4">
              <div class="stat-label">{{ 'etykieta.kwota' | translate }}</div>
              <div class="stat-value text-primary">{{ item.kwota | kwota }}</div>
            </div>
            <div class="col-4">
              <div class="stat-label">{{ 'etykieta.kwota-zaplacona' | translate }}</div>
              <div class="stat-value text-success">{{ item.kwotaZaplacona | kwota }}</div>
            </div>
            <div class="col-4">
              <div class="stat-label">{{ 'etykieta.kwota-pozostala' | translate }}</div>
              <div class="stat-value" [ngClass]="{'text-danger': item.kwotaPozostala > 0}">{{ item.kwotaPozostala |
                kwota }}</div>
            </div>
          </div>
          <div class="row" *ngIf="item.url">
            <div class="col-12 text-center">
              <a target="_blank" [href]="item.url" nbButton status="primary" size="small">
                <nb-icon icon="download-outline"></nb-icon>
                {{ 'akcja.pobierz' | translate }}
              </a>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>

<ng-template #hdrTpl let-column="column" let-sort="sortFn">
  <span class="font-weight-bold text-wrap" (click)="sort()">{{ column.name }}</span>
  <span [hidden]="!wyswietlanieFiltrow || !showFilters">
    <br />
    <input nbInput fieldSize="small" type="search" class="w-75" (input)="updateFilter($event, column.prop)" />
  </span>
</ng-template>